var _style, _path, _path2, _path3, _rect, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _path4, _path5, _ellipse7, _path6, _ellipse8, _rect2, _rect3, _path7, _rect4, _path8, _path9, _ellipse9, _path10, _ellipse10, _ellipse11, _rect5, _rect6, _rect7, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _polygon, _path19, _path20, _rect8, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _rect9, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgObiHiltOld(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 35 200",
    style: {
      enableBackground: "new 0 0 35 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0oho{fill:#161616;}\r\n\t.st1oho{fill:#A3A09D;}\r\n\t.st2oho{fill:#1E1E1E;}\r\n\t.st3oho{fill:#2D2D2D;}\r\n\t.st4oho{fill:#42413F;}\r\n\t.st5oho{fill:#898680;}\r\n\t.st6oho{fill:#6A6A6A;}\r\n\t.st7oho{fill:#BC1F2E;}\r\n\t.st8oho{fill:#B51A21;}\r\n\t.st9oho{fill:#B7A946;}\r\n\t.st10oho{fill:#CCC04E;}\r\n\t.st11oho{fill:#931915;}\r\n\t.st12oho{fill:#676768;}\r\n\t.st13oho{fill:#89611F;}\r\n\t.st14oho{fill:#3A3A3A;}\r\n\t.st15oho{fill:#232322;}\r\n\t.st16oho{fill:#222323;}\r\n\t.st17oho{fill:#303031;}\r\n\t.st18oho{fill:#252526;}\r\n\t.st19oho{opacity:0.57;fill:#222323;}\r\n\t.st20oho{fill:#818484;}\r\n\t.st21oho{fill:#8D8D8E;}\r\n\t.st22oho{opacity:0.57;fill:#ADADAD;}\r\n\t.st23oho{fill:#999998;}\r\n\t.st24oho{fill:#9E9E9B;}\r\n\t.st25oho{fill:#ADADAD;}\r\n\t.st26oho{fill:#9E9E9E;}\r\n\t.st27oho{fill:#878787;}\r\n\t.st28oho{fill:#969696;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0oho",
    d: "M9.3,172.3c-1.1-1.2-2.3-2.3-3.4-3.5c2.9,1,7.2,2.1,12.4,2c4.4-0.1,8.1-1,10.8-2c-1.6,1.4-3.1,2.7-4.7,4.1 c-2.9,0.5-5.9,1-8.8,1.5C13.5,173.6,11.4,172.9,9.3,172.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1oho",
    d: "M4.8,11c-1-2-2-3.9-3-5.9C6,3.8,11.8,2.4,18.8,2.6C24.9,2.7,30,3.8,33.7,5c-1.3,2.2-2.5,4.3-3.8,6.5 C21.6,11.3,13.2,11.2,4.8,11z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1oho",
    d: "M5.4,4.7C5.3,3.7,5.2,2.8,5.1,1.9C8,1,11.8,0.2,16.3,0c5.8-0.2,10.6,0.8,14.1,1.8c0,1.1,0,2.2,0,3.3 C22,5,13.7,4.8,5.4,4.7z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.3,
    y: 7.3,
    className: "st2oho",
    width: 20.6,
    height: 32.7
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st3oho",
    cx: 16.5,
    cy: 29.7,
    rx: 10.4,
    ry: 1.2
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st3oho",
    cx: 16.5,
    cy: 26,
    rx: 10.4,
    ry: 1.2
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st3oho",
    cx: 16.5,
    cy: 22.5,
    rx: 10.4,
    ry: 1.2
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st3oho",
    cx: 16.6,
    cy: 19,
    rx: 10.4,
    ry: 1.2
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st3oho",
    cx: 16.6,
    cy: 15.6,
    rx: 10.4,
    ry: 1.2
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st3oho",
    cx: 16.6,
    cy: 11.9,
    rx: 10.4,
    ry: 1.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4oho",
    d: "M6.4,8.6c-0.7,0.3-1.3,0.7-2,1c0,9.8,0,19.5,0,29.3c3.4,1.6,6.9,3.2,10.3,4.9c5.3-1.9,10.7-3.8,16-5.7 c-0.2-9.6-0.4-19.2-0.6-28.7c-1.4-0.3-2.7-0.6-4.1-0.9c0,6.4,0,12.7,0,19.1c-1,1.5-2.5,3.2-4.4,5c-1.7,1.5-3.4,2.7-4.8,3.4 c0,1.1,0,2.3,0,3.4c-0.5,0.8-1.3,1.2-2,1c-0.7-0.2-1.1-0.9-1.2-1c0-1.2,0-2.4,0-3.5c-1.3-0.8-3.3-2.1-5.2-4.5 c-1.1-1.5-1.9-2.9-2.4-4.1C6.3,21,6.4,14.8,6.4,8.6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5oho",
    d: "M27.9,35.9c-1.7-1-2.6-3-2.3-4.9c0.4-2.1,2.1-3,2.3-3.1c1.7,0.8,2.8,2.8,2.5,4.7C30.3,34.1,29.3,35.3,27.9,35.9 z"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st6oho",
    cx: 29.2,
    cy: 31.8,
    rx: 1.1,
    ry: 2.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5oho",
    d: "M5.2,36.6c1.7-1,2.6-3,2.3-4.9c-0.4-2.1-2.1-3-2.3-3.1c-1.7,0.8-2.8,2.8-2.5,4.7C2.8,34.8,3.8,36.1,5.2,36.6z"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st6oho",
    cx: 3.9,
    cy: 32.6,
    rx: 1.1,
    ry: 2.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.9,
    y: 75.2,
    className: "st1oho",
    width: 23,
    height: 17.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6.6,
    y: 58.3,
    className: "st1oho",
    width: 21.9,
    height: 11.8
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1oho",
    d: "M7.1,58.7c-0.9-0.7-1.8-1.4-2.6-2.1c8.8,0,17.6,0,26.4,0c-1.1,0.9-2.2,1.7-3.3,2.6 C20.7,59.1,13.9,58.9,7.1,58.7z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 4.4,
    y: 38,
    className: "st1oho",
    width: 26.4,
    height: 18.7
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1oho",
    d: "M6.3,75.6c-0.4-0.1-0.9-0.2-1.3-0.3c0-1.6,0-3.1,0-4.7c0.4-0.6,0.9-1.1,1.3-1.7c7.5,0,15,0,22.5,0 c0.4,0.6,0.7,1.3,1.1,1.9c0,1.5,0,3,0,4.4c-0.5,0.2-0.9,0.4-1.4,0.6C21.1,75.8,13.7,75.7,6.3,75.6z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st7oho",
    d: "M2.4,54.3c1.4,0,2.8,0,4.2,0c0.5-1.2,1.1-3.1,1.1-5.4c0-2.3-0.6-4.1-1.1-5.3c-1.3,0-2.6,0-4,0 C2.5,47.2,2.5,50.7,2.4,54.3z"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st8oho",
    cx: 2.5,
    cy: 49,
    rx: 2.3,
    ry: 5.3
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st9oho",
    d: "M30.3,49.7c-1.1,0-2.2,0-3.3,0c-0.4-0.7-0.9-1.8-0.9-3.1c0-1.3,0.5-2.3,0.9-3c1,0,2.1,0,3.1,0 C30.2,45.6,30.3,47.7,30.3,49.7z"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st10oho",
    cx: 30.4,
    cy: 46.7,
    rx: 1.7,
    ry: 3
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st11oho",
    cx: 30.5,
    cy: 46.7,
    rx: 1.1,
    ry: 1.7
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 6.6,
    y: 58.3,
    className: "st4oho",
    width: 21.9,
    height: 0.3
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 6.6,
    y: 68.6,
    className: "st4oho",
    width: 21.9,
    height: 0.3
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 5.9,
    y: 75.5,
    className: "st4oho",
    width: 23.2,
    height: 0.3
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st3oho",
    d: "M21.7,157.4h-8.3c-4.1,0-7.5-3.8-7.5-8.4C6,128.6,6,108.2,6,87.8c0.4-0.4,1-0.9,1.8-1.3c2.1-1.1,4-1,5.3-0.9 c8.6,0.4,9.5-0.4,12.3,1.1c1.6,0.8,2.8,1.8,3.4,2.4c0.1,20,0.1,40,0.2,59.9C29.1,153.6,25.8,157.4,21.7,157.4z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st12oho",
    d: "M7.6,140.9c2.6,0.8,6.2,1.6,10.4,1.6c3.4,0,6.4-0.6,8.7-1.2c0.1-0.8,0.1-1.5,0.2-2.3c-3,0.4-6.5,0.7-10.4,0.7 c-3.3-0.1-6.4-0.4-9-0.9C7.5,139.5,7.5,140.2,7.6,140.9z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st12oho",
    d: "M7.6,133.9c2.6,0.8,6.2,1.6,10.4,1.6c3.4,0,6.4-0.6,8.7-1.2c0.1-0.8,0.1-1.5,0.2-2.3c-3,0.4-6.5,0.7-10.4,0.7 c-3.3-0.1-6.4-0.4-9-0.9C7.5,132.6,7.5,133.3,7.6,133.9z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st12oho",
    d: "M7.6,127c2.6,0.8,6.2,1.6,10.4,1.6c3.4,0,6.4-0.6,8.7-1.2c0.1-0.8,0.1-1.5,0.2-2.3c-3,0.4-6.5,0.7-10.4,0.7 c-3.3-0.1-6.4-0.4-9-0.9C7.5,125.6,7.5,126.3,7.6,127z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st12oho",
    d: "M7.6,120c2.6,0.8,6.2,1.6,10.4,1.6c3.4,0,6.4-0.6,8.7-1.2c0.1-0.8,0.1-1.5,0.2-2.3c-3,0.4-6.5,0.7-10.4,0.7 c-3.3-0.1-6.4-0.4-9-0.9C7.5,118.6,7.5,119.3,7.6,120z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st12oho",
    d: "M7.3,113c2.6,0.8,6.2,1.6,10.4,1.6c3.4,0,6.4-0.6,8.7-1.2c0.1-0.8,0.1-1.5,0.2-2.3c-3,0.4-6.5,0.7-10.4,0.7 c-3.3-0.1-6.4-0.4-9-0.9C7.2,111.6,7.3,112.3,7.3,113z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st12oho",
    d: "M8,105.7c2.6,0.8,6.2,1.6,10.4,1.6c3.4,0,6.4-0.6,8.7-1.2c0.1-0.8,0.1-1.5,0.2-2.3c-3,0.4-6.5,0.7-10.4,0.7 c-3.3-0.1-6.4-0.4-9-0.9C7.9,104.3,7.9,105,8,105.7z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st12oho",
    d: "M7.6,98.5c2.6,0.8,6.2,1.6,10.4,1.6c3.4,0,6.4-0.6,8.7-1.2c0.1-0.8,0.1-1.5,0.2-2.3c-3,0.4-6.5,0.7-10.4,0.7 c-3.3-0.1-6.4-0.4-9-0.9C7.5,97.1,7.5,97.8,7.6,98.5z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st13oho",
    points: "24.9,91.6 21.9,95 19,91.6 21.9,88.3 "
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st14oho",
    d: "M15.5,96.1L15.5,96.1c-1.1,0-2-0.9-2-2v-4.2c0-1.1,0.9-2,2-2h0c1.1,0,2,0.9,2,2v4.2 C17.5,95.2,16.6,96.1,15.5,96.1z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st15oho",
    d: "M15.5,95.5L15.5,95.5c-0.8,0-1.4-0.6-1.4-1.4V93c0-0.8,0.6-1.4,1.4-1.4h0c0.8,0,1.4,0.6,1.4,1.4v1.1 C16.9,94.9,16.3,95.5,15.5,95.5z"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 6.8,
    y: 184.3,
    className: "st14oho",
    width: 21,
    height: 9
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st16oho",
    d: "M8.6,174.5c-0.3-0.7-0.4-1.7,0-3.2c2,0.8,5.1,1.7,8.9,1.7c3.8,0,6.8-0.9,8.8-1.7c0,1.4,0,2.7,0,4.1 C17.1,178.2,10,177.9,8.6,174.5z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st17oho",
    d: "M7.4,178.4c-0.9-0.6-1.3-1.7-1-2.8c0.2-1,1-1.7,1.9-1.7c1.7,0.9,4.7,2.2,8.5,2.4c4.5,0.2,8.1-1.2,9.9-2.1 c1,0.3,1.4,0.8,1.6,1.3c0.4,1-0.3,4.3-0.1,3.3l0,0c0,0-3.5,0.8-10.1,2.4c-2.9-0.4-5.9-0.7-8.8-1.1C8.6,179.6,8,179,7.4,178.4z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st18oho",
    d: "M3.8,183.2c-0.2-1.4-0.3-2.8-0.5-4.1c0.9-0.6,1.8-1.1,2.8-1.7c2.2,1.1,5.7,2.5,10.2,2.8 c5.8,0.3,10.3-1.4,12.7-2.5c1.2,1,2.5,2,3.7,3c-1,1.3-2,2.5-3,3.8c-5,0.5-9.9,1-14.9,1.5c-3.1,0.1-6.2,0.2-9.3,0.3 C5.1,185.2,4.5,184.2,3.8,183.2z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st19oho",
    d: "M5.5,190.8c2,5.2,6.4,8.8,11.3,9.1c5.5,0.4,10.8-3.3,13-9.1C21.7,190.8,13.6,190.8,5.5,190.8z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st20oho",
    d: "M34.7,183.6c0-1.2,0-2.3-0.1-3.5c-1,0-2.1,0.1-3.1,0.1c0,1-0.1,2.1-0.1,3.1C32.5,183.4,33.6,183.5,34.7,183.6z "
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st21oho",
    d: "M30.6,178.7c0.7,0,1.3,0,2,0c0.7,0.5,1.4,1,2.1,1.5c-1,0-2.1,0.1-3.1,0.1C31.2,179.7,30.9,179.2,30.6,178.7z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st20oho",
    d: "M0.6,180.2c0,1.2,0.1,2.3,0.1,3.5c1-0.3,2-0.6,3-0.8c-0.1-1-0.1-1.9-0.2-2.9C2.5,180,1.5,180.1,0.6,180.2z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st21oho",
    d: "M3.1,178.6c-0.8,0.5-1.7,1.1-2.5,1.6c0.9,0,1.9,0,2.8,0c0.4-0.5,0.9-1.1,1.3-1.6 C4.1,178.6,3.6,178.6,3.1,178.6z"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 186.8,
    className: "st22oho",
    width: 7.1,
    height: 6.6
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st23oho",
    d: "M27,191c0-2.2-0.1-4.4-0.1-6.7c1.7,0.2,3.5,0.3,5.2,0.5c0,2.2,0,4.3,0.1,6.5C30.5,191.2,28.8,191.1,27,191z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st24oho",
    d: "M34.9,183.5c-0.9,0.6-1.8,1.1-2.8,1.7c0,2,0,4,0.1,6.1c0.9-0.6,1.9-1.2,2.8-1.7 C35,187.5,34.9,185.5,34.9,183.5z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st25oho",
    d: "M31.2,182.4c-1.4,0.6-2.9,1.3-4.3,1.9c1.8,0.3,3.5,0.6,5.3,0.9c0.9-0.6,1.8-1.1,2.7-1.7 C33.7,183.2,32.5,182.8,31.2,182.4z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st23oho",
    d: "M8.2,184.5c0,2.1-0.1,4.3-0.1,6.4c-1.7,0-3.4,0-5.1,0c-0.1-2.1-0.1-4.2-0.2-6.3C4.6,184.6,6.4,184.5,8.2,184.5 z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st24oho",
    d: "M0,189.5c1,0.5,2,0.9,3,1.4c0-2,0-4,0-6c-1-0.4-2-0.8-2.9-1.2C0,185.7,0,187.6,0,189.5z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st25oho",
    d: "M3.5,182.5c-1.1,0.4-2.3,0.8-3.4,1.2c1,0.4,2,0.8,2.9,1.2c1.7-0.2,3.5-0.3,5.2-0.5 C6.6,183.8,5.1,183.2,3.5,182.5z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st26oho",
    d: "M22,187.2c-3,0-6,0-9,0c0-0.3,0-0.6,0-0.9c3,0,6,0,9,0C22,186.7,22,186.9,22,187.2z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st27oho",
    d: "M22.1,192.5c-0.3,0.3-0.6,0.6-1,0.9c0-2.1,0-4.2,0-6.3c0.3-0.3,0.6-0.5,0.9-0.8 C22.1,188.4,22.1,190.5,22.1,192.5z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st27oho",
    d: "M13,192.7c0.3,0.3,0.7,0.5,1,0.8c0-2.1,0-4.1,0-6.2c-0.3-0.3-0.7-0.6-1-0.9C13,188.5,13,190.6,13,192.7z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st28oho",
    d: "M4.2,147.4c3.1,1.1,7.7,2.4,13.2,2.5c5.6,0.2,10.2-0.8,13.4-1.8c0,6.4,0,12.9,0,19.3c-1.4,1-2.9,2.1-4.3,3.1 c-3.8,0.4-7.6,0.7-11.4,1.1c-2.5-0.7-5-1.3-7.6-2c-1.1-0.7-2.2-1.4-3.3-2.1C4.1,160.8,4.2,154.1,4.2,147.4z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st28oho",
    d: "M4.2,147.4c0.6-0.8,1.1-1.6,1.7-2.4c0.3,0.3,0.6,0.7,0.8,1c0.1,0,0.6-0.1,1.1,0.3c0.5,0.5,0.4,1.3,0.4,1.4 c0.2,0.2,0.5,0.5,0.8,0.7c1.3,0.9,2.7,0.9,3.4,0.8c3.2,0,6.4,0,9.6,0c0.4-0.2,0.9-0.5,1.5-1.1c0.5-0.5,0.9-1,1.1-1.4 c0.6,0,1.6-0.1,2.6-0.5c0.8-0.3,1.5-0.7,1.9-1.1c0.5,0.5,1.1,1.1,1.6,1.6c0,0.5,0,0.9,0,1.4c-2.6,1.4-7.9,3.8-14.8,3.3 c-5.1-0.3-9.1-2.1-11.5-3.4C4.3,147.9,4.3,147.7,4.2,147.4z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgObiHiltOld);
export default __webpack_public_path__ + "static/media/obi-hilt-old.03f37ff0.svg";
export { ForwardRef as ReactComponent };